import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export function StatusCard({
  title,
  value,
  ok,
  detail,
  actionLabel,
  onClick,
}: {
  title: string;
  value: string;
  ok: boolean;
  detail: string;
  actionLabel?: string;
  onClick?: () => void;
}) {
  return (
    <Box
      component={onClick ? "button" : "div"}
      onClick={onClick}
      sx={{
        textAlign: "left",
        border: "1px solid #d0d5dd",
        borderRadius: "2px",
        bgcolor: "#fff",
        p: 2,
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick ? { borderColor: "#1a4f8c" } : undefined,
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{ mb: 0.75, alignItems: "center" }}
      >
        {ok ? (
          <CheckCircleOutlineIcon sx={{ color: "#067647", fontSize: 20 }} />
        ) : (
          <WarningAmberIcon sx={{ color: "#b54708", fontSize: 20 }} />
        )}
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "0.85rem",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "text.secondary",
          }}
        >
          {title}
        </Typography>
      </Stack>
      <Typography sx={{ fontWeight: 700, fontSize: "1.35rem", mb: 0.35 }}>
        {value}
      </Typography>
      <Typography sx={{ color: "text.secondary", fontSize: "0.9rem" }}>
        {detail}
      </Typography>
      {actionLabel && onClick ? (
        <Typography
          sx={{
            mt: 1.25,
            color: "primary.main",
            fontWeight: 700,
            fontSize: "0.85rem",
          }}
        >
          {actionLabel} →
        </Typography>
      ) : null}
    </Box>
  );
}
